export default "__VITE_ASSET__e7e916e5__"